var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-hero-carousel" },
    [
      _c(
        "agile",
        {
          ref: "main",
          staticClass: "main-carousel",
          attrs: { "as-nav-for": _vm.asNavFor1, options: _vm.options1 },
        },
        [
          _c("template", { attrs: { type: "div" }, slot: "prevButton" }, [
            _c(
              "svg",
              {
                staticClass: "icon",
                staticStyle: { "enable-background": "new 0 0 50 50" },
                attrs: {
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 50 50",
                  "xml:space": "preserve",
                },
              },
              [
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "7.895" },
                }),
                _vm._v(" "),
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "42.105" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            {
              attrs: {
                title: "Next Slide",
                alt: "Next Slide",
                "aria-label": "Next Slide",
              },
              slot: "nextButton",
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "7.895",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "42.105",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.items, function (item, imageIndex) {
            return _c(
              "div",
              { key: imageIndex, staticClass: "slide feature-slide" },
              [_c("ProductHero", { attrs: { content: item } })],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "agile",
        {
          ref: "thumbnails",
          staticClass: "navigation-carousel",
          attrs: { "as-nav-for": _vm.asNavFor2, options: _vm.options2 },
        },
        [
          _c("template", { attrs: { type: "div" }, slot: "prevButton" }, [
            _c(
              "svg",
              {
                staticClass: "icon",
                staticStyle: { "enable-background": "new 0 0 50 50" },
                attrs: {
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 50 50",
                  "xml:space": "preserve",
                },
              },
              [
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "7.895" },
                }),
                _vm._v(" "),
                _c("line", {
                  staticClass: "ls",
                  attrs: { x1: "16.618", y1: "25", x2: "33.382", y2: "42.105" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "template",
            {
              attrs: {
                title: "Next Slide",
                alt: "Next Slide",
                "aria-label": "Next Slide",
              },
              slot: "nextButton",
            },
            [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  staticStyle: { "enable-background": "new 0 0 50 50" },
                  attrs: {
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    viewBox: "0 0 50 50",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "7.895",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                  _vm._v(" "),
                  _c("line", {
                    staticClass: "ls",
                    attrs: {
                      x1: "16.618",
                      y1: "42.105",
                      x2: "33.382",
                      y2: "25",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.items, function (item, imageIndex) {
            return _c(
              "div",
              {
                key: imageIndex,
                staticClass: "slide slide-thumbnail",
                attrs: { title: item.author },
                on: {
                  click: function ($event) {
                    return _vm.$refs.thumbnails.goTo(imageIndex)
                  },
                },
              },
              [
                _c("div", { staticClass: "slide-inner" }, [
                  _c("div", { staticClass: "bottle-image-container" }, [
                    _c("img", {
                      staticClass: "bottle-image",
                      attrs: { src: item.thumbnail.fileStore.presignedURL },
                    }),
                  ]),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }